const API = 'UserPatientProfileWeeklyReports';

export const API_USER_PATIENT_PROFILE_WEEKLY_REPORTS = {
  GET_ALL_DYNAMIC: `${API}/GetAllDynamic`,
  POST: `${API}/Create`,
  PATCH: (data: Pick<Components.Schemas.UserPatientProfileWeeklyReport, 'id'>) =>
    `${API}/Patch/${data.id}`,
  DELETE: (data: Pick<Components.Schemas.UserPatientProfileWeeklyReport, 'id'>) =>
    `${API}/Delete/${data.id}`,
};
export interface AppUserPatientProfileWeeklyReport
  extends Components.Schemas.UserPatientProfileWeeklyReport {}

export type UserPatientProfileWeeklyReportShort = Pick<AppUserPatientProfileWeeklyReport, 'id' | 'reportDate'>;

export type UserPatientProfileWeeklyReportPatch = Pick<AppUserPatientProfileWeeklyReport, 'id' | 'done'>;
export interface UserPatientProfileWeeklyReportInput {
  done: boolean;
  year: number;
}
export interface UserPatientProfileWeeklyReportItem {
  id: string;
  reportDate: string;
  done: boolean;
  totalCount: number;
  requiringAttentionCount: number;
  countNotWeighedInOver10Days: number;
  countMonthSlow: number;
  countMonthNotLosingWeight: number;
  countSubscriptionSlow: number;
  countSubscriptionNotLosingWeight: number;
  countNewSubscription: number;
  countMaintenanceWeight: number;
  reviewedCount: number;
  highlightCount: number;
}

export interface UserPatientProfileWeeklyReportItemForReview {
  id: string;
  activityIDs: string[];
}
export interface ReviewInput {
  id: string;
  userEmployeeProfileID: string;
}
